import { useState, useEffect } from 'react'
import React from 'react';
import '../styles/App.css';
import GuessSword from './GuessSword.js';
import InputSword from './InputSword.js';
import GrilleSword from './GrilleSword.js';
import Countdown from './Countdown.js';
import Prev from './Prev.js';
import Rules from './Rules.js';
import Nav from './Nav.js';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;


function ModeSword() {

  const gameMode = 'sword'

  // Crée un nouvel objet Date avec la date et l'heure actuelles
  var dateDuJour = new Date();
  // Récupère les composantes de la date
  var annee = dateDuJour.getFullYear();
  var mois = (dateDuJour.getMonth() + 1).toString().padStart(2, '0'); // Les mois commencent à 0 en JS, donc on ajoute 1
  var jour = dateDuJour.getDate().toString().padStart(2, '0');
  // Formate la date en "yyyy-mm-dd"
  var dateFormatee = `${annee}-${mois}-${jour}`;


  const [swordFind, setswordFind] = useState(0);
  const savedrowsLocal = localStorage.getItem('rows-swords')
  let savedrows = null;
  if (savedrowsLocal ) {  savedrows =  JSON.parse(savedrowsLocal).filter(row => row.dateFormatee === dateFormatee && row.gameMode === gameMode); }
  // const savednbTestMax = localStorage.getItem('nbTestMax')
  const [swordNow, setSwordNow] = useState([]);
  const [nbTest, nbTestUpdate] = useState(savedrows ? savedrows.length : 0)
  const [nbTestMax, nbTestMaxUpdate] = useState(nbTest === 10 ? 1 : 0)

  
  // Initialiser gameNow avec l'item du jour
  useEffect(() => {
    const fetchswordNow = async () => {
      try {
        const response = await fetch(URL_BACKEND+'/api/swords-now');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const swordNow = await response.json();
        console.log('Data itemNow fetched successfully:', swordNow);
        setSwordNow(swordNow);
        console.log('swordNow', swordNow);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchswordNow();
  }, []);

  
	const [rows, rowsUpdate] = useState(savedrows ? savedrows : [])
  // Stockage des inputs dans le localstorage + mise à jour
	useEffect(( ) => {
    if (swordNow.length === 0) {
      // Wait until gameNow is fetched
      return;
    }
		localStorage.setItem('rows-swords', JSON.stringify(rows))

    // Mise à jour du nombre de coup
    nbTestUpdate(rows.length)
    console.log('lenght', rows.length)
    // Mise à jour si le nombre de coup est de 10
    rows.length === 10 ? nbTestMaxUpdate(1) : nbTestMaxUpdate(0)
    
    // Mise à jour si le nombre de coup est de 10
    if (rows.length > 0 && rows[0].id_epee === swordNow.id_epee) { setswordFind(1) } else  { setswordFind(0) }


	}, [rows, swordNow])

    return (
      <div >
        <Nav />
        
        <InputSword       
            gameMode={gameMode} 
            rows={rows}
            rowsUpdate={rowsUpdate}
            swordNow={swordNow}
            setSwordNow={setSwordNow}
            swordFind={swordFind}
            nbTestMax={nbTestMax}
            nbTest={nbTest}
            dateFormatee={dateFormatee}
        />
        {nbTestMax === 1 || swordFind === 1 ?
          <Countdown />
          : <GuessSword       
              gameMode={gameMode} 
              swordNow={swordNow}
              nbTest={nbTest}
          />
        }
        
        <GrilleSword
            gameMode={gameMode} 
            rows={rows}
            rowsUpdate={rowsUpdate}
            swordNow={swordNow}
        />
        
        <Prev 
          gameMode={gameMode} 
        />
        <Rules 
          gameMode={gameMode} 
        />   
    </div>
	)
}

export default ModeSword
